  const tabs = document.querySelectorAll(".tabs a");

  if (typeof(tabs) != 'undefined' && tabs != null) {
    
    const tabContents = document.querySelectorAll(".tabs-content li");
    
    // Hide all tab contents except the first one
    tabContents.forEach((content, index) => {
        content.style.display = index === 0 ? "block" : "none";
    });

    tabs.forEach((tab, index) => {
        tab.addEventListener("click", function(event) {
            event.preventDefault();

            // Remove active class from all tabs and hide all tab contents
            tabs.forEach(t => t.classList.remove("active"));
            tabContents.forEach(content => content.style.display = "none");

            // Add active class to clicked tab and show corresponding content
            tab.classList.add("active");
            tabContents[index].style.display = "block";
        });
    });
  }

var reviews_tab = document.getElementById('b_tab_liquid_G8HcXd');
if (typeof(reviews_tab) != 'undefined' && reviews_tab != null) {
  document.getElementById('b_tab_liquid_G8HcXd').addEventListener('click', function() {
    // Trigger the window resize event
    window.dispatchEvent(new Event('resize'));
  });
}



function openSizeGuide() {
  document.getElementById('sizeGuideLightbox').style.display = 'block';
}

function closeSizeGuide() {
  document.getElementById('sizeGuideLightbox').style.display = 'none';
}

// // Function to handle scrolling and make the button fixed after a certain point
// window.onscroll = function() {
//   var sizeGuideContainer = document.getElementById('sizeGuideContainer');
//   var stickyOffset = 350; // Adjust this value to set when the button should become sticky
//   if (window.pageYOffset > stickyOffset) {
//     sizeGuideContainer.classList.add('fixed');
//   } else {
//     sizeGuideContainer.classList.remove('fixed');
//   }
// };

// Close the lightbox if clicked outside of the content area
window.onclick = function(event) {
  if (event.target === document.getElementById('sizeGuideLightbox')) {
    closeSizeGuide();
  }
};


jQuery(document).ready(function ($) {
    // Define the magnificPopupT4s settings
    var magnificPopupOptions = {
        type: "ajax",
        removalDelay: 500,
        tClose: "Close",
        tLoading: '<div class="t4s-loading-spin t4s-spin-centered t4s-spin-dark t4s-spin-medium"></div>',
        callbacks: {
            parseAjax: function (e) {
                var i = $(this.st.el),
                    a = i.data("id") || "",
                    n = i.data("class") || "",
                    o = i.data("style") || "",
                    s = e.data;
                e.data = `<div class="mfp-with-anim t4s-mfp-popup t4s-rte ${n}" id="${a}" style="${o}">${s.split("[t4splitlz]")[1] || s}</div>`;
            },
            beforeOpen: function () {
                $("body").addClass("is-opening-mfp");
                this.st.mainClass = "mfp-move-horizontal t4s-ajax-popup-wrapper";
            },
            open: function () {
                console.log("Popup Opened");
            },
            afterClose: function () {
                $("body").removeClass("is-opening-mfp");
            }
        }
    };

    // Function to apply magnificPopupT4s to "Learn More" when it appears
    function initializePopup() {
        var learnMoreLinkEpo = $(".easify-product-options").find(".t4s-ch");
        var learnMoreLinkIo = $("#infiniteoptions-container").find(".t4s-ch");
        var learnMoreLink = learnMoreLinkEpo.length ? learnMoreLinkEpo : learnMoreLinkIo;

        if (learnMoreLink.length) {
            // Apply magnificPopupT4s only if it hasn't been initialized
            if (!learnMoreLink.hasClass("t4s-mfp-enabled")) {
                learnMoreLink.addClass("t4s-mfp-enabled");

                learnMoreLink.magnificPopupT4s(magnificPopupOptions);

                console.log("magnificPopupT4s applied to Learn More link.");
            }
        }
    }

    // Observe DOM changes to detect when "Learn More" is added
    var observer = new MutationObserver(function () {
        initializePopup();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Run once in case the "Learn More" link is already present
    initializePopup();
});


// Read more/less

var showChar = 350,
	ellipsestext = " ...",
	moretext = " Read more",
	lesstext = " Read less";

document.querySelectorAll(".collapsing-parag").forEach(function (el) {
	const fullHTML = el.innerHTML;
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = fullHTML;

	// Extract text content (with spaces)
	const fullText = tempDiv.textContent || tempDiv.innerText || "";

	if (fullText.length <= showChar) {
		return; // No need to truncate
	}

	// Truncate at the last space before showChar
	const cutoff = fullText.lastIndexOf(" ", showChar);
	const shortText = fullText.slice(0, cutoff);

	// Rebuild HTML up to cutoff point
	let truncatedHTML = "";
	let charCount = 0;

	function preserveHTMLUpTo(nodeList) {
		for (let node of nodeList) {
			if (charCount >= cutoff) break;

			if (node.nodeType === Node.TEXT_NODE) {
				let text = node.textContent;
				let remaining = cutoff - charCount;

				if (text.length > remaining) {
					truncatedHTML += text.slice(0, remaining);
					charCount = cutoff;
					break;
				} else {
					truncatedHTML += text;
					charCount += text.length;
				}
			} else if (node.nodeType === Node.ELEMENT_NODE) {
				let clone = document.createElement(node.nodeName);
				for (let attr of node.attributes) {
					clone.setAttribute(attr.name, attr.value);
				}

				let before = truncatedHTML.length;
				preserveHTMLUpTo(node.childNodes);
				let inner = truncatedHTML.slice(before);
				clone.innerHTML = inner;
				truncatedHTML = truncatedHTML.slice(0, before) + clone.outerHTML;
			}
		}
	}

	preserveHTMLUpTo(tempDiv.childNodes);

	// Store versions in dataset
	el.dataset.fullContent = fullHTML;
	el.dataset.truncated = truncatedHTML;

	// Set initial HTML
	el.innerHTML = truncatedHTML +
		'<span class="moreellipses">' + ellipsestext + '</span>' +
		'<a href="#" class="morelink">' + moretext + '</a>';
});

// Toggle full/truncated content
document.addEventListener("click", function (e) {
	if (e.target.matches(".morelink")) {
		e.preventDefault();
		const link = e.target;
		const container = link.closest(".collapsing-parag");

		if (link.classList.contains("less")) {
			container.innerHTML = container.dataset.truncated +
				'<span class="moreellipses">' + ellipsestext + '</span>' +
				'<a href="#" class="morelink">' + moretext + '</a>';
		} else {
			container.innerHTML = container.dataset.fullContent +
				'<a href="#" class="morelink less">' + lesstext + '</a>';
		}
	}
});


